import styled from "@emotion/styled";
import { CloseIcon, SearchWavyIcon } from "components/Icons";
import { useIsMobile } from "hooks/useDeviceType";
import { useRef } from "react";
import { GlobalStore } from "store/global/GlobalStore";

interface SearchTokenFilterInputProps {
  value: string;
  setValue: React.Dispatch<React.SetStateAction<string>>;
}

export const SearchTokenFilterInput = ({ value, setValue }: SearchTokenFilterInputProps) => {
  const theme = GlobalStore.useState(s => s.theme);
  const ref = useRef<HTMLInputElement>(null);
  const isMobile = useIsMobile();

  const icon =
    value !== "" ? (
      <CloseIcon
        width={22}
        height={22}
        color={theme.font.primary.default}
        onClick={() => setValue("")}
      />
    ) : (
      <SearchWavyIcon
        width={22}
        height={22}
        color={theme.font.quaternary.default}
        onClick={() => ref.current?.focus({})}
      />
    );

  return (
    <>
      <SearchTokenFilterInputContainer
        type={"text"}
        placeholder={"Search"}
        value={value}
        onChange={e => setValue(e.target.value)}
        ref={ref}
      />
      <IconContainer isMobile={isMobile}>{icon}</IconContainer>
    </>
  );
};

// Sub-components

const SearchTokenFilterInputContainer = styled.input(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  borderRadius: "14px",
  marginRight: "4px",
  background: "black",
  color: theme.font.primary.default,
  height: "42px",
  width: "100%",
  border: 0,
  padding: "10px 10px 10px 14px",
  marginBottom: "8px",
  position: "sticky",
  top: 0,
  ":focus": {
    outline: `1px solid ${theme.button.primary.surface.active}`,
  },
}));

const IconContainer = styled.div<{ isMobile: boolean }>`
  position: absolute;
  right: ${props => (props.isMobile ? 16 : 20)}px;
  top: ${props => (props.isMobile ? 8 : 18)}px;
  svg {
    cursor: pointer;
  }
`;
